import React, { useState, useEffect } from 'react';
import Select from 'react-select';
const axios = require('axios').default;
const CityChosen = ({ category, cities, handleCityChoice, formData, l }) => {
    const [options, setOptions] = useState([]);
    useEffect(() => {
        let array = [];
        for (let i = 0; i < cities.length; i++) {
            let city = cities[i];
            array.push({ value: city.slug, label: city.name });
        }
        setOptions([...array]);
        return () => {
        };
    }, []);
    let defaultValue = false;
    if (formData.chosenCity != null)
        defaultValue = formData.chosenCity;
    const onChange = (value) => {
        handleCityChoice(value);
    };
    const customStyles = {
        Placeholder: (p, s) => {
            return Object.assign(Object.assign({}, p), { color: category == "dis" ? "#ffffff" : "#1F2D60", opacity: 1 });
        },
        menuList: (p, s) => {
            return Object.assign(Object.assign({}, p), { padding: 0, overflow: "hidden", outline: s.isFocused ? 0 : 0, border: s.isFocused ? 0 : 0 });
        },
        option: (p, s) => {
            return {
                background: s.isFocused && !s.isSelected ? "rgba(255,255,255,0.3)" : (s.isSelected ? "var(--main-color)" : "#ffffff"),
                color: s.isSelected && category == "dis" ? "#ffffff" : "#1F2D60",
                paddingTop: 7,
                paddingBottom: 7,
                paddingLeft: 15,
                paddingRight: 15,
                outline: s.isFocused ? 0 : 0,
                border: s.isFocused ? 0 : 0,
            };
        },
        menu: (provided, state) => (Object.assign(Object.assign({}, provided), { color: "#1F2D60", background: "#ffffff", outline: state.isFocused ? 0 : 0, border: state.isFocused ? 0 : 0 })),
        control: (provided, state) => (Object.assign(Object.assign({}, provided), { color: category == "dis" ? "#ffffff" : "#1F2D60", borderRadius: 10, outline: state.isFocused ? 0 : 0, border: state.isFocused ? 0 : 0 })),
        indicatorSeparator: (p, s) => (Object.assign(Object.assign({}, s), { borderColor: "transparent" })),
        singleValue: (provided, state) => {
            return Object.assign(Object.assign({}, provided), { color: category == "dis" ? "#ffffff" : "#1F2D60", paddingLeft: 50, paddingTop: 10, paddingBottom: 10, outline: state.isFocused ? 0 : 0, border: state.isFocused ? 0 : 0, fontWeight: 500 });
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'city-chosen' },
            React.createElement("h2", null, l("cityChosen")),
            React.createElement(Select, { placeholder: l("cityChosenPlaceholder"), isSearchable: false, isClearable: true, options: options, defaultValue: defaultValue, onChange: onChange, styles: customStyles }))));
};
export default CityChosen;
